const ChakraChannels = () => {
  return (
    <section className="bg-white py-20 px-4 sm:px-6 lg:px-20">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          The Three Channels (Nadis)
        </h2>
        <p className="text-gray-600 max-w-3xl mx-auto leading-relaxed">
          In Sahaja Yoga, the subtle system includes three channels (nadis) through which our energy flows:
          the left channel (<strong>Ida Nadi</strong>), the right channel (<strong>Pingala Nadi</strong>), and
          the central channel (<strong>Sushumna Nadi</strong>). Together, they govern our past, future, and present
          state of balance and spiritual evolution.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {/* Left Channel */}
        <div
          className="bg-blue-50 p-6 rounded-2xl shadow-sm border border-blue-100"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h3 className="text-xl font-semibold text-blue-700 mb-2">
            Left Channel (Ida Nadi)
          </h3>
          <p className="text-gray-700 text-sm leading-relaxed">
            Governs our past, emotions, and desires. Expresses through the left body side and ends in the right brain hemisphere.
            Imbalance may lead to depression or lethargy.
          </p>
        </div>

        {/* Central Channel */}
        <div
          className="bg-gray-100 p-6 rounded-2xl shadow-sm border border-gray-200"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            Central Channel (Sushumna Nadi)
          </h3>
          <p className="text-gray-700 text-sm leading-relaxed">
            Represents present awareness and spiritual ascent. It’s the channel through which Kundalini energy rises,
            bringing balance and joy through meditation.
          </p>
        </div>

        {/* Right Channel */}
        <div
          className="bg-yellow-50 p-6 rounded-2xl shadow-sm border border-yellow-100"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <h3 className="text-xl font-semibold text-yellow-700 mb-2">
            Right Channel (Pingala Nadi)
          </h3>
          <p className="text-gray-700 text-sm leading-relaxed">
            Governs actions and planning. Expresses through the right side of the body and ends in the left brain hemisphere.
            Overuse may result in ego, stress, or aggression.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ChakraChannels;
